export default __webpack_public_path__ + "static/media/pricing-house-2.ed55323a.svg";